export const artistsData = [
  {
    id: 1,
    name: 'NEON GHOST',
    location: 'TOKYO',
    prefecture: 'tokyo',
    genre: 'Experimental Electronic / Noise',
    image: 'https://public.readdy.ai/ai/img_res/b9b1f83bde1bc13cbad2b6e7b6481711.jpg',
    platforms: ['youtube', 'soundcloud', 'spotify'],
    color: '#00ff41',
    playerData: {
      trackName: 'Digital Void',
      trackLabel: 'Single',
      duration: '4:32',
      playerSnsUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ'
    },
    creditsData: [
      {
        name: 'RUST ECHO',
        genre: 'Post-Rock',
        location: 'KYOTO',
        description: 'ギターとエフェクト処理を担当',
        imageUrl: 'https://readdy.ai/api/search-image?query=indie%20rock%20guitarist%20with%20electric%20guitar%20and%20effect%20pedals%20in%20atmospheric%20studio%20space%20soft%20cyan%20and%20pink%20lighting%20minimalist%20setup%20focusing%20on%20instruments%20and%20creative%20mood%20simple%20background&width=400&height=400&seq=artist3&orientation=squarish',
        artistUserId: '',
        snsUrl: 'https://soundcloud.com/rustecho'
      }
    ],
    socialsData: [
      {
        platform: 'YouTube',
        icon: 'ri-youtube-line',
        username: '@neonghost',
        url: 'https://youtube.com/@neonghost'
      },
      {
        platform: 'SoundCloud',
        icon: 'ri-soundcloud-line',
        username: 'neon-ghost',
        url: 'https://soundcloud.com/neon-ghost'
      },
      {
        platform: 'Spotify',
        icon: 'ri-spotify-line',
        username: 'NEON GHOST',
        url: 'https://open.spotify.com/artist/neonghost'
      }
    ]
  },
  {
    id: 2,
    name: '夜行性',
    location: 'OSAKA',
    prefecture: 'osaka',
    genre: 'Lo-fi Hip Hop / Jazz Fusion',
    image: 'https://readdy.ai/api/search-image?query=japanese%20lofi%20hiphop%20artist%20with%20turntables%20and%20vinyl%20records%20in%20dimly%20lit%20room%20warm%20orange%20and%20blue%20lighting%20urban%20night%20atmosphere%20simple%20clean%20background%20showcasing%20music%20production%20setup&width=400&height=400&seq=artist2&orientation=squarish',
    platforms: ['soundcloud', 'spotify', 'instagram'],
    color: '#ff006e',
    playerData: {
      trackName: '深夜の街',
      trackLabel: 'EP',
      duration: '3:45',
      playerSnsUrl: 'https://soundcloud.com/yakosei/midnight-city'
    },
    creditsData: [],
    socialsData: [
      {
        platform: 'SoundCloud',
        icon: 'ri-soundcloud-line',
        username: 'yakosei',
        url: 'https://soundcloud.com/yakosei'
      },
      {
        platform: 'Instagram',
        icon: 'ri-instagram-line',
        username: '@yakosei_music',
        url: 'https://instagram.com/yakosei_music'
      }
    ]
  },
  {
    id: 3,
    name: 'RUST ECHO',
    location: 'KYOTO',
    prefecture: 'kyoto',
    genre: 'Post-Rock / Ambient',
    image: 'https://readdy.ai/api/search-image?query=indie%20rock%20guitarist%20with%20electric%20guitar%20and%20effect%20pedals%20in%20atmospheric%20studio%20space%20soft%20cyan%20and%20pink%20lighting%20minimalist%20setup%20focusing%20on%20instruments%20and%20creative%20mood%20simple%20background&width=400&height=400&seq=artist3&orientation=squarish',
    platforms: ['youtube', 'spotify', 'instagram'],
    color: '#00d9ff',
    playerData: {
      trackName: 'Echoes in Rust',
      trackLabel: 'Album',
      duration: '6:18',
      playerSnsUrl: ''
    },
    creditsData: [
      {
        name: 'NEON GHOST',
        genre: 'Electronic',
        location: 'TOKYO',
        description: 'シンセサイザーとプロダクション',
        imageUrl: 'https://readdy.ai/api/search-image?query=underground%20electronic%20music%20producer%20in%20dark%20studio%20with%20neon%20lights%20and%20synthesizers%20creating%20experimental%20sounds%20moody%20atmospheric%20lighting%20with%20purple%20and%20green%20glow%20minimalist%20background%20focused%20on%20equipment%20and%20creative%20energy&width=400&height=400&seq=artist1&orientation=squarish',
        artistUserId: '',
        snsUrl: ''
      },
      {
        name: '夜行性',
        genre: 'Lo-fi Hip Hop',
        location: 'OSAKA',
        description: 'ビートメイキングとサンプリング',
        imageUrl: 'https://readdy.ai/api/search-image?query=japanese%20lofi%20hiphop%20artist%20with%20turntables%20and%20vinyl%20records%20in%20dimly%20lit%20room%20warm%20orange%20and%20blue%20lighting%20urban%20night%20atmosphere%20simple%20clean%20background%20showcasing%20music%20production%20setup&width=400&height=400&seq=artist2&orientation=squarish',
        artistUserId: '',
        snsUrl: 'https://soundcloud.com/yakosei'
      }
    ],
    socialsData: [
      {
        platform: 'YouTube',
        icon: 'ri-youtube-line',
        username: '@rustecho',
        url: 'https://youtube.com/@rustecho'
      },
      {
        platform: 'Spotify',
        icon: 'ri-spotify-line',
        username: 'RUST ECHO',
        url: 'https://open.spotify.com/artist/rustecho'
      },
      {
        platform: 'Instagram',
        icon: 'ri-instagram-line',
        username: '@rust_echo',
        url: 'https://instagram.com/rust_echo'
      }
    ]
  },
  {
    id: 4,
    name: '深層',
    location: 'FUKUOKA',
    prefecture: 'fukuoka',
    genre: 'Dark Techno / Industrial',
    image: 'https://readdy.ai/api/search-image?query=techno%20dj%20with%20modular%20synthesizer%20and%20drum%20machines%20in%20dark%20underground%20club%20setting%20red%20and%20blue%20neon%20lights%20industrial%20aesthetic%20simple%20background%20emphasizing%20electronic%20music%20equipment&width=400&height=400&seq=artist4&orientation=squarish',
    platforms: ['soundcloud', 'youtube', 'spotify'],
    color: '#b537f2'
  },
  {
    id: 5,
    name: 'VOID WALKER',
    location: 'NAGOYA',
    prefecture: 'nagoya',
    genre: 'Shoegaze / Dream Pop',
    image: 'https://readdy.ai/api/search-image?query=shoegaze%20band%20member%20with%20guitar%20and%20reverb%20pedals%20in%20hazy%20dreamy%20atmosphere%20soft%20purple%20and%20pink%20lighting%20ethereal%20mood%20simple%20clean%20background%20focusing%20on%20musical%20instruments%20and%20ambiance&width=400&height=400&seq=artist5&orientation=squarish',
    platforms: ['spotify', 'instagram', 'youtube'],
    color: '#00ff41'
  },
  {
    id: 6,
    name: '衝動',
    location: 'SAPPORO',
    prefecture: 'sapporo',
    genre: 'Punk / Garage Rock',
    image: 'https://readdy.ai/api/search-image?query=punk%20rock%20musician%20with%20bass%20guitar%20in%20raw%20garage%20setting%20harsh%20white%20and%20red%20lighting%20gritty%20underground%20aesthetic%20simple%20background%20capturing%20rebellious%20energy%20and%20raw%20sound&width=400&height=400&seq=artist6&orientation=squarish',
    platforms: ['youtube', 'soundcloud', 'instagram'],
    color: '#ff006e'
  },
  {
    id: 7,
    name: 'STATIC BLOOM',
    location: 'SENDAI',
    prefecture: 'sendai',
    genre: 'Indie Folk / Acoustic',
    image: 'https://readdy.ai/api/search-image?query=indie%20folk%20artist%20with%20acoustic%20guitar%20in%20warm%20intimate%20studio%20space%20soft%20golden%20and%20green%20lighting%20cozy%20atmosphere%20simple%20minimalist%20background%20highlighting%20acoustic%20instruments%20and%20natural%20sound&width=400&height=400&seq=artist7&orientation=squarish',
    platforms: ['spotify', 'youtube', 'instagram'],
    color: '#00d9ff'
  },
  {
    id: 8,
    name: '残響',
    location: 'HIROSHIMA',
    prefecture: 'hiroshima',
    genre: 'Math Rock / Progressive',
    image: 'https://readdy.ai/api/search-image?query=math%20rock%20drummer%20with%20complex%20drum%20kit%20setup%20in%20modern%20practice%20space%20cool%20blue%20and%20white%20lighting%20technical%20precision%20atmosphere%20simple%20background%20showcasing%20intricate%20percussion%20equipment&width=400&height=400&seq=artist8&orientation=squarish',
    platforms: ['youtube', 'soundcloud', 'spotify'],
    color: '#b537f2'
  },
  {
    id: 9,
    name: '鹿鳴',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Ambient / Field Recording',
    image: 'https://readdy.ai/api/search-image?query=ambient%20music%20artist%20with%20field%20recording%20equipment%20and%20headphones%20in%20serene%20natural%20forest%20setting%20with%20soft%20green%20and%20golden%20light%20minimalist%20background%20capturing%20peaceful%20sound%20exploration%20atmosphere&width=400&height=400&seq=artist9&orientation=squarish',
    platforms: ['soundcloud', 'spotify', 'youtube'],
    color: '#00ff41'
  },
  {
    id: 10,
    name: 'KASUGA',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Post-Punk / Darkwave',
    image: 'https://readdy.ai/api/search-image?query=post%20punk%20darkwave%20musician%20with%20synthesizer%20and%20bass%20guitar%20in%20dark%20moody%20room%20with%20red%20and%20cyan%20neon%20strip%20lights%20on%20concrete%20walls%20underground%20aesthetic%20minimalist%20background&width=400&height=400&seq=artist10&orientation=squarish',
    platforms: ['youtube', 'instagram', 'spotify'],
    color: '#ff006e'
  },
  {
    id: 11,
    name: '古都ノイズ',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Noise / Experimental',
    image: 'https://readdy.ai/api/search-image?query=experimental%20noise%20artist%20with%20contact%20microphones%20and%20effect%20pedals%20creating%20harsh%20sounds%20in%20dimly%20lit%20industrial%20space%20with%20flickering%20green%20neon%20light%20raw%20underground%20performance%20atmosphere&width=400&height=400&seq=artist11&orientation=squarish',
    platforms: ['soundcloud', 'youtube', 'instagram'],
    color: '#00d9ff'
  },
  {
    id: 12,
    name: 'YAMATO DRIFT',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Lo-fi Beats / Chillhop',
    image: 'https://readdy.ai/api/search-image?query=lofi%20beat%20producer%20with%20MPC%20drum%20machine%20and%20vinyl%20sampler%20in%20cozy%20bedroom%20studio%20warm%20orange%20lamp%20light%20and%20soft%20pink%20neon%20glow%20relaxed%20creative%20atmosphere%20simple%20clean%20background&width=400&height=400&seq=artist12&orientation=squarish',
    platforms: ['spotify', 'soundcloud', 'instagram'],
    color: '#b537f2'
  },
  {
    id: 13,
    name: '春日野',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Shoegaze / Dream Pop',
    image: 'https://readdy.ai/api/search-image?query=dreamy%20shoegaze%20guitarist%20with%20multiple%20reverb%20and%20delay%20pedals%20on%20pedalboard%20in%20hazy%20atmospheric%20room%20with%20soft%20cyan%20and%20white%20lighting%20ethereal%20mood%20simple%20background%20with%20fog%20effect&width=400&height=400&seq=artist13&orientation=squarish',
    platforms: ['youtube', 'spotify', 'instagram'],
    color: '#00ff41'
  },
  {
    id: 14,
    name: 'NARAZAKI',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Hardcore Punk / Grindcore',
    image: 'https://readdy.ai/api/search-image?query=hardcore%20punk%20vocalist%20screaming%20into%20microphone%20in%20raw%20underground%20venue%20with%20harsh%20red%20and%20white%20lighting%20aggressive%20energy%20sweat%20and%20intensity%20simple%20dark%20background%20with%20stage%20lights&width=400&height=400&seq=artist14&orientation=squarish',
    platforms: ['youtube', 'soundcloud', 'instagram'],
    color: '#ff006e'
  },
  {
    id: 15,
    name: '大仏BASS',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Dubstep / Bass Music',
    image: 'https://readdy.ai/api/search-image?query=bass%20music%20producer%20with%20large%20studio%20monitors%20and%20subwoofer%20in%20dark%20room%20with%20deep%20blue%20and%20green%20LED%20lighting%20heavy%20electronic%20music%20production%20setup%20simple%20minimalist%20background&width=400&height=400&seq=artist15&orientation=squarish',
    platforms: ['soundcloud', 'spotify', 'youtube'],
    color: '#00d9ff'
  },
  {
    id: 16,
    name: 'SILK ROAD',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'World Fusion / Electronic',
    image: 'https://readdy.ai/api/search-image?query=world%20fusion%20electronic%20musician%20with%20traditional%20instruments%20and%20modern%20synthesizer%20blending%20cultures%20in%20atmospheric%20studio%20with%20warm%20golden%20and%20teal%20lighting%20eclectic%20creative%20space%20simple%20background&width=400&height=400&seq=artist16&orientation=squarish',
    platforms: ['spotify', 'youtube', 'instagram'],
    color: '#b537f2'
  },
  {
    id: 17,
    name: '若草',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Indie Rock / Alternative',
    image: 'https://readdy.ai/api/search-image?query=indie%20rock%20band%20guitarist%20with%20fender%20jazzmaster%20guitar%20in%20rehearsal%20room%20with%20warm%20amber%20and%20green%20lighting%20vintage%20amplifier%20in%20background%20casual%20creative%20atmosphere%20simple%20clean%20background&width=400&height=400&seq=artist17&orientation=squarish',
    platforms: ['youtube', 'spotify', 'soundcloud'],
    color: '#00ff41'
  },
  {
    id: 18,
    name: 'DEER CREEK',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Folk / Singer-Songwriter',
    image: 'https://readdy.ai/api/search-image?query=folk%20singer%20songwriter%20with%20acoustic%20guitar%20sitting%20on%20wooden%20stool%20in%20intimate%20candlelit%20room%20warm%20golden%20light%20soft%20and%20peaceful%20atmosphere%20simple%20rustic%20background%20with%20natural%20wood%20textures&width=400&height=400&seq=artist18&orientation=squarish',
    platforms: ['spotify', 'instagram', 'youtube'],
    color: '#ff006e'
  },
  {
    id: 19,
    name: '飛火野',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Techno / Minimal',
    image: 'https://readdy.ai/api/search-image?query=minimal%20techno%20DJ%20with%20CDJ%20turntables%20and%20mixer%20in%20dark%20club%20booth%20with%20subtle%20white%20and%20cyan%20LED%20strip%20lighting%20focused%20concentration%20on%20mixing%20clean%20modern%20DJ%20setup%20simple%20dark%20background&width=400&height=400&seq=artist19&orientation=squarish',
    platforms: ['soundcloud', 'spotify', 'youtube'],
    color: '#00d9ff'
  },
  {
    id: 20,
    name: 'TODAIJI',
    location: 'NARA',
    prefecture: 'nara',
    genre: 'Drone / Doom Metal',
    image: 'https://readdy.ai/api/search-image?query=doom%20metal%20guitarist%20with%20heavy%20downtuned%20guitar%20and%20massive%20amplifier%20stack%20in%20dark%20smoky%20room%20with%20deep%20red%20and%20orange%20lighting%20slow%20heavy%20atmosphere%20simple%20industrial%20background&width=400&height=400&seq=artist20&orientation=squarish',
    platforms: ['youtube', 'soundcloud', 'instagram'],
    color: '#b537f2'
  }
];
